import React from "react";

interface ApprovalStatusProps {
  data: {
    title: string;
    items: Array<{
      id: number;
      label: string;
      statusText: string;
      status: string;
    }>;
  };
}

const ApprovalStatus: React.FC<ApprovalStatusProps> = ({ data }) => {
  return (
    <div className="bottom-card">
      <div className="si-header">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" style={{ flexShrink: 0 }}>
          <path d="M7.5 1.5L2 3.5v4c0 3 2.5 5.5 5.5 6 3-0.5 5.5-3 5.5-6v-4L7.5 1.5z" stroke="#165697" strokeWidth="1.3" strokeLinejoin="round"/>
          <path d="M5 7.5l2 2 3-3" stroke="#165697" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span className="si-header-label">Executive Approval Status</span>
      </div>

      <div className="as-inner-card">
        {data.items.map((item, idx) => (
          <div key={item.id} className={`as-row${idx < data.items.length - 1 ? " as-row--bordered" : ""}`}>
            <span className={`as-row-label${idx === 0 ? " as-row-label--italic" : ""}`}>{item.label}</span>
            <span className="as-row-value">{item.statusText}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApprovalStatus;
